// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"3f909ec6","2725":"0a23f272"}[chunkId] + ".chunk.css";
};